@if (lineSize === 0) {
  <div class="radio-group" [ngClass]="orientation" [attr.disabled]="notEnabled ? '' : null"
    [style.marginTop.px]="marginTop">
    @for (so of options; track so) {
      <div class="radio">
        <aa-radio [toTranslate]="toTranslate" [option]="so" name="{{ name }}"> </aa-radio>
      </div>
    }
  </div>
}
@if (lineSize !== 0) {
  <div class="radio-group" [attr.disabled]="notEnabled ? '' : null"
    [style.marginTop.px]="marginTop">
    <table>
      @for (line of lines; track line; let i = $index) {
        <tr>
          @for (so of options.slice(i * lineSize, (i + 1) * lineSize); track so) {
            <td>
              <aa-radio [toTranslate]="toTranslate" [option]="so" name="{{ name }}"> </aa-radio>
            </td>
          }
        </tr>
      }
    </table>
  </div>
}
